import { wrapWithGTM } from "./utils";
import addToCart from "./functions/addToCart/addToCart";
import addShippingInfo from "./functions/addShippingInfo/addShippingInfo";
import addPaymentInfo from "./functions/addPaymentInfo/addPaymentInfo";
import beginCheckout from "./functions/beginCheckout/beginCheckout";
import viewCart from "./functions/viewCart/viewCart";
import checkoutStep from "./functions/checkoutStep/checkoutStep.js";
import productsImpression from "./functions/productsImpression/productsImpression";
import removeFromCart from "./functions/removeFromCart/removeFromCart";
import purchase from "./functions/purchase/purchase";

const handlers = {
  addToCart,
  addShippingInfo,
  addPaymentInfo,
  productsImpression,
  beginCheckout,
  viewCart,
  checkoutStep,
  removeFromCart,
  purchase,
};

export const registerGTMEvent = Object.fromEntries(
  Object.entries(handlers).map(([key, fn]) => [key, wrapWithGTM(fn)]),
);
